import { useRef, useState } from "react";
import { Mic, MicOff } from "lucide-react";
import { toast } from "sonner";

// Reusable voice dictation button. Calls onText(finalChunk) with each finalised
// transcript chunk so the parent can append it wherever it needs.
export const VoiceButton = ({ onText, size = 16, className = "", title = "Dictate with voice", testId }) => {
  const [listening, setListening] = useState(false);
  const recognitionRef = useRef(null);

  const start = () => {
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SR) {
      toast.error("Voice input not supported. Try Chrome or Edge.");
      return;
    }
    const recognition = new SR();
    recognition.continuous = true;
    recognition.interimResults = true;
    recognition.lang = "en-AU";
    recognition.onstart = () => {
      setListening(true);
      toast.info("Listening... speak now");
    };
    recognition.onresult = (e) => {
      let final = "";
      for (let i = e.resultIndex; i < e.results.length; i++) {
        if (e.results[i].isFinal) final += e.results[i][0].transcript + " ";
      }
      if (final) onText(final);
    };
    recognition.onerror = (e) => {
      if (e.error !== "no-speech") toast.error(`Voice error: ${e.error}`);
      setListening(false);
    };
    recognition.onend = () => setListening(false);
    recognitionRef.current = recognition;
    recognition.start();
  };

  const stop = () => {
    recognitionRef.current?.stop();
    setListening(false);
    toast.success("Voice captured");
  };

  return (
    <button
      type="button"
      onClick={() => (listening ? stop() : start())}
      data-testid={testId}
      title={title}
      className={`flex items-center justify-center transition-colors cursor-pointer border-none bg-transparent ${listening ? "text-red-400 animate-pulse" : ""} ${className}`}
    >
      {listening ? <MicOff size={size} /> : <Mic size={size} />}
    </button>
  );
};

export default VoiceButton;
